import * as React from "react";
import {
  required,
  SelectInput,
  TextInput,
  DateInput,
  BooleanInput,
} from "react-admin";

const CreateClient = () => (
  <>
    <TextInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      inputProps={{ maxLength: 64 }}
      source="middle_name"
      validate={[required()]}
    />
    <SelectInput
      sx={{ width: "14%" }}
      label="resources.Client.fields.sex.name"
      choices={[
        { id: "female", name: "resources.Client.fields.sex.female" },
        {
          id: "male",
          name: "resources.Client.fields.sex.male",
        },
      ]}
      optionText="name"
      optionValue="id"
      source="sex"
      validate={[required()]}
    />

    <DateInput
      sx={{ width: "14%" }}
      source="date_of_birth"
      validate={[required()]}
    />
    <BooleanInput
      source="terms_agreement_confirm"
      defaultValue={true}
      validate={[required()]}
    />
  </>
);

export default CreateClient;
